module.exports = __webpack_public_path__ + "static/img/u302.a64376d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u302.png
// module id = 8kxI
// module chunks = 1